import React from "react";

/**
 * Input component renders a customizable input field.
 *
 * @param {Object} props - The properties object.
 * @param {string} [props.className="custInput qualy"] - The CSS class name for the input element.
 * @param {string} [props.placeholder="Enter text"] - The placeholder text for the input element.
 * @param {string} [props.type="text"] - The type of the input element.
 * @param {string} [props.value=""] - The value of the input element.
 * @param {function} [props.onChange=() => {}] - The function to call when the input value changes.
 * @param {number} [props.limit] - The maximum number of characters allowed in the input.
 * @param {Object} [props.props] - Additional properties to pass to the input element.
 * @returns {JSX.Element} The rendered input element.
 */
export default function Input({
  className = "custInput qualy",
  placeholder = "Enter text",
  type = "text",
  value = "",
  onChange = () => {},
  limit,
  ...props
}) {
  const handleOnChange = (event) => {
    const { value } = event.target;
    if (limit && value.length > limit) return;
    onChange(event);
  };
  return (
    <input
      {...props}
      className={className}
      placeholder={placeholder}
      type={type}
      value={value}
      onChange={handleOnChange}
    ></input>
  );
}
